import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Layout from './pages/Layout.tsx';
import Home from './pages/Home.tsx';
import Privacidad from './pages/Privacidad.tsx';
import AvisoLegal from './pages/AvisoLegal.tsx';
import Cookies from './pages/Cookies.tsx';
import PageNotFound from './pages/PageNotFound.tsx';

function App() {
  return (
    <div style={container}>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route path='/' element={<Home />} />
          <Route path='/privacidad' element={<Privacidad />} />
          <Route path='/aviso-legal' element={<AvisoLegal />} />
          <Route path='/cookies' element={<Cookies />} />
          <Route path='*' element={<PageNotFound />} />
        </Route>

      </Routes>
    </div>
  );
}

export default App;
const container: any = {
  textAlign: "left"
}